import * as Sentry from '@sentry/browser';
import { SERVICE_ENV } from '../constant';
import app_info from '../../../package.json';
import { LANG } from '../translation';

const DENY_URLS = [
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  /instagram/i,
  /hotjar/i,
  /googletagmanager/i,
];

const IGNORE_ERRORS = [
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  /Loading chunk [\d]+ failed/,
  /Loading CSS chunk [\d]+ failed/,
  'SecurityError',
  /googleads/i,
  /googlesyndication/i,
  'TypeError: Failed to fetch',
  'TypeError: NetworkError when attempting to fetch resource.',
  'TypeError: Cancelled',
  /Network Error/,
  // /Invariant Violation: Minified invariant #\d+; %s Params: %s/, // 인스타그램 오류
  /__gCrWeb/i, // iOS Chrome error
  /__naverapp__/i,
];

Sentry.init({
  dsn:
    SERVICE_ENV !== 'development'
      ? 'https://0d32509d72def40af7d3c6506e6068fd@o4505344647757824.ingest.us.sentry.io/4507934365057024'
      : null,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  denyUrls: DENY_URLS,
  ignoreErrors: IGNORE_ERRORS,
  maxValueLength: 500,
  normalizeDepth: 5,
  environment: SERVICE_ENV,
  version: `${app_info.name}@${app_info.version}`,
  release: `${app_info.name}@${app_info.version}`,
});
if (window.ReactNativeWebView) Sentry.setTag('is_app', true);
Sentry.setTag('lang', LANG);
Sentry.setExtra('referrer', document.referrer);
